module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("终端安全不合规")]), _c('br'), _c('br'), _vm._v("\n               "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("同学你好，你的PC终端安全不合规")]), _vm._v("。为规范我公司办公网计算机风险威胁防范工作，保证办公网络和办公信息系统的安全稳定运行，\n        特推广落实终端安全管理解决方案，请务必保证PC终端已安装和运行赛门铁克杀毒软件、数据防泄漏客户端（DLP）和美团安全管理客户端（MOA），\n        请根据以下步骤进行检查终端不合规的详细原因并进行修复。"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v("1、打开MOA客户端页面，点击“安全基线检查”按钮；")]), _c('br'), _c('br'), _vm._v("\n        a.windows打开MOA客户端方法，如下图所示单击以下图标；"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic01.png"),
      "width": "500px",
      "height": "150px"
    }
  }), _c('br'), _vm._v("\n        在跳出的MOA客户端界面上选择“安全基线检查”选项，查看安全基线检查结果。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic02.png"),
      "width": "600px",
      "height": "400px"
    }
  }), _c('br'), _vm._v("\n        b、Mac系统打开MOA客户端方法：点击运行的MOA图标。在跳出的MOA客户端界面上选择“安全基线检测”选项，查看安全基线检查结果。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic03.png"),
      "width": "600px",
      "height": "400px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v("2、排查“安全基线检查”。")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic04.png"),
      "width": "800px",
      "height": "500px"
    }
  }), _c('br'), _c('br'), _vm._v("\n        a.赛门铁克杀毒软件已安装 显示红色\n        "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic05.png"),
      "width": "40px",
      "height": "30px"
    }
  }), _vm._v("\n        ，表示赛门铁克杀毒软件未安装，请从此处进入\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/saimenInstallForWin')
      }
    }
  }, [_vm._v("杀软安装指南—Windows")]), _vm._v("，\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/saimenInstallForMac')
      }
    }
  }, [_vm._v("杀软安装指南--macOS")]), _vm._v("。"), _c('br'), _vm._v("\n        b.数据防泄漏客户端已安装 显示红色\n        "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic05.png"),
      "width": "40px",
      "height": "30px"
    }
  }), _vm._v("\n        ，表示数据防泄漏客户端未安装，请从此处进入\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/dataLeakInstallForWin')
      }
    }
  }, [_vm._v("DLP安装指南--Windows")]), _vm._v("，\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/dataLeakInstallForMac')
      }
    }
  }, [_vm._v("DLP安装指南--macOS")]), _vm._v("。"), _c('br'), _vm._v("\n        c.赛门铁克杀毒软件已运行 显示红色\n        "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic05.png"),
      "width": "40px",
      "height": "30px"
    }
  }), _vm._v("\n        ，表示数据防泄漏客户端未安装，请从此处进入\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/windowRepairUnstart')
      }
    }
  }, [_vm._v("杀软安装指南—Windows")]), _vm._v("，\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/macRepairUnstart')
      }
    }
  }, [_vm._v("杀软安装指南--macOS")]), _vm._v("。"), _c('br'), _vm._v("\n        d.数据防泄漏客户端已运行 显示红色\n        "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic05.png"),
      "width": "40px",
      "height": "30px"
    }
  }), _vm._v("\n        ，表示数据防泄漏客户端未安装，请从此处进入\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/dataLeakInstallForWin')
      }
    }
  }, [_vm._v("DLP安装指南--Windows")]), _vm._v("，\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/dataLeakInstallForMac')
      }
    }
  }, [_vm._v("DLP安装指南--macOS")]), _vm._v("。"), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v("3、以上提示的红色修复完成后，请重新登录应用系统，如还有问题，请大象联系6000")]), _c('br'), _vm._v("\n        a.如遇特殊情紧急情况，员工可申请临时白名单，申请页面请从此进入\n        "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/whiteApply')
      }
    }
  }, [_vm._v("临时白名单")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0301cd45!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/terminalIllegal.vue
// module id = 633
// module chunks = 1